/**
 * Every heuristic knob lives here so detection behaviour can be tuned without
 * changing the algorithms. Ratios are in the inclusive 0..1 range.
 */
export const ANALYSIS_THRESHOLDS = Object.freeze({
  alpha: Object.freeze({
    transparent: 0,
    opaque: 255,
    nearOpaque: 250,
  }),
  boundary: Object.freeze({
    quantizationStep: 16,
  }),
  classification: Object.freeze({
    edgeContentRatio: 0.2,
    transparentPaddingMinPixels: 2,
    transparentPaddingMinFraction: 0.01,
  }),
  solidBackground: Object.freeze({
    quantizationStep: 16,
    maximumSamples: 20_000,
    cornerPatchRadius: 2,
    minimumSamples: 8,
    dominantRatio: 0.82,
    opaqueRatio: 0.96,
    /** Mean squared RGB distance from the mean. */
    maximumVariance: 420,
    whiteLuminance: 244,
    lightGrayLuminance: 174,
    darkGrayLuminance: 72,
    neutralChannelSpread: 18,
  }),
  checkerboard: Object.freeze({
    edgeBandFraction: 0.18,
    minimumEdgeBandPixels: 2,
    maximumEdgeBandPixels: 48,
    maximumSamples: 50_000,
    minimumSamples: 48,
    quantizationStep: 8,
    nearOpaqueAlpha: 250,
    opaqueRatio: 0.94,
    neutralChannelSpread: 20,
    lightColorMinimum: 176,
    minimumPaletteDistance: 12,
    maximumPaletteDistance: 150,
    assignmentDistance: 42,
    minimumPaletteCoverage: 0.8,
    minimumTileSize: 2,
    maximumTileSize: 32,
    minimumAxisComparisons: 12,
    minimumAxisPeriodicity: 0.72,
    minimumCombinedPeriodicity: 0.76,
    minimumPaletteBalance: 0.22,
  }),
  asyncAnalysis: Object.freeze({
    rowsPerChunk: 128,
  }),
  trim: Object.freeze({
    allowedPadding: Object.freeze([0, 2, 4, 8, 16] as const),
  }),
});

export type AnalysisThresholds = typeof ANALYSIS_THRESHOLDS;
